//@flow
import React from 'react';
import styled, { keyframes } from 'styled-components';

export default ({
  className,
  style,
  color,
  animated = true,
}: {
  className?: string,
  style?: any,
  color?: string,
  animated?: boolean,
}) => {
  color = color ? color : 'white';
  return (
    <Svg
      className={className}
      style={style}
      width="512"
      height="244"
      viewBox="0 0 512 244"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>Spine Idaho Logo</title>
      <g id="Canvas" transform="translate(13628 4206)">
        <g id="Logo">
          <g id="Vector">
            <use
              xlinkHref="#path0_fill"
              transform="translate(-13557.6 -4112.07)"
              fill={color}
            />
          </g>
          <g id="Vector">
            <use
              xlinkHref="#path1_fill"
              transform="translate(-13536.7 -4112.07)"
              fill={color}
            />
          </g>
          <g id="Vector">
            <use
              xlinkHref="#path2_fill"
              transform="translate(-13594.1 -4112.07)"
              fill={color}
            />
          </g>
          <g id="Vector">
            <use
              xlinkHref="#path3_fill"
              transform="translate(-13628 -4112.27)"
              fill={color}
            />
          </g>
          <g id="Vector">
            <use
              xlinkHref="#path4_fill"
              transform="translate(-13495 -4112.07)"
              fill={color}
            />
          </g>
          <g id="Vector">
            <use
              xlinkHref="#path5_fill"
              transform="translate(-13378.5 -4112.07)"
              fill={color}
            />
          </g>
          <g id="Vector">
            <use
              xlinkHref="#path6_fill"
              transform="translate(-13251.9 -4112.07)"
              fill={color}
            />
          </g>
          <g id="Vector">
            <use
              xlinkHref="#path7_fill"
              transform="translate(-13358 -4112.07)"
              fill={color}
            />
          </g>
          <g id="Vector">
            <use
              xlinkHref="#path8_fill"
              transform="translate(-13288.4 -4112.07)"
              fill={color}
            />
          </g>
          <g id="Vector">
            <use
              xlinkHref="#path9_fill"
              transform="translate(-13238 -4112.07)"
              fill={color}
            />
          </g>
          <g id="Vector">
            <use
              xlinkHref="#path9_fill"
              transform="translate(-13170.1 -4112.07)"
              fill={color}
            />
          </g>
          <g id="Vector">
            <use
              xlinkHref="#path10_fill"
              transform="translate(-13274.4 -3996.33)"
              fill={color}
            />
          </g>
          <g id="Vector">
            <use
              xlinkHref="#path11_fill"
              transform="translate(-13318.4 -4112.27)"
              fill={color}
            />
          </g>
          <g id="Vector">
            <use
              xlinkHref="#path12_fill"
              transform="translate(-13134.6 -4112.07)"
              fill={color}
            />
          </g>
          <g id="Vector">
            <use
              xlinkHref="#path13_fill"
              transform="translate(-13203 -4112.07)"
              fill={color}
            />
          </g>
          <g id="Vector">
            <use
              xlinkHref="#path14_fill"
              transform="translate(-13338.1 -3996.38)"
              fill={color}
            />
          </g>
          <g id="Vector">
            <use
              xlinkHref="#path15_fill"
              transform="translate(-13376.5 -3996.62)"
              fill={color}
            />
          </g>
          <g id="Vector">
            <use
              xlinkHref="#path16_fill"
              transform="translate(-13131.1 -3996.62)"
              fill={color}
            />
          </g>
          <g id="Vector">
            <use
              xlinkHref="#path17_fill"
              transform="translate(-13244.5 -3996.38)"
              fill={color}
            />
          </g>
          <g id="Vector">
            <use
              xlinkHref="#path18_fill"
              transform="translate(-13208.4 -3996.31)"
              fill={color}
            />
          </g>
          <g id="Vector">
            <use
              xlinkHref="#path19_fill"
              transform="translate(-13168.2 -3996.33)"
              fill={color}
            />
          </g>
          <HoverGroup id="Group">
            <g id="Vector">
              <use
                xlinkHref="#path20_fill"
                transform="translate(-13476 -4206)"
                fill="#D32A58"
              />
            </g>
            <g id="Vector">
              <use
                xlinkHref="#path21_fill"
                transform="translate(-13437 -4188.07)"
                fill="#D32A58"
              />
            </g>
          </HoverGroup>
        </g>
      </g>
      <defs>
        <path
          id="path0_fill"
          d="M 4.74499 0L 0 0L 0 100.588L 4.74499 100.588L 4.74499 0Z"
        />
        <path
          id="path1_fill"
          d="M 21.4159 -1.16986e-06L 21.4159 94.1736L 8.22126 -1.16986e-06L 4.25899e-06 -1.16986e-06L 4.25899e-06 100.588L 4.74499 100.588L 4.74499 1.5078L 18.6247 100.588L 26.1609 100.588L 26.1609 -1.16986e-06L 21.4159 -1.16986e-06Z"
        />
        <path
          id="path2_fill"
          d="M 10.5303 -1.16986e-06L -2.90385e-07 -1.16986e-06L -2.90385e-07 100.588L 4.74499 100.588L 4.74499 52.0318L 13.2707 52.0318C 14.6213 52.0357 15.9581 51.7582 17.197 51.2168C 18.436 50.6753 19.5504 49.8817 20.4702 48.8857C 21.39 47.8897 22.0954 46.7128 22.542 45.4291C 22.9885 44.1454 23.1667 42.7825 23.0652 41.4261L 23.0652 9.14902C 23.0652 2.93893 18.371 -1.16986e-06 10.5303 -1.16986e-06ZM 18.371 42.065C 18.371 43.0362 18.1172 47.9429 13.2961 47.9429L 4.71961 47.9429L 4.71961 3.96116L 10.5303 3.96116C 14.1081 3.96116 18.371 4.85562 18.371 9.07235L 18.371 42.065Z"
        />
        <path
          id="path3_fill"
          d="M 0.608982 11.596L 0.608982 27.1852C 0.608982 34.1108 6.31819 44.921 11.2154 52C 16.6455 59.8456 18.0918 65.1613 18.0918 67.0779L 18.0918 90.0783C 18.0918 96.0072 17.1023 96.9528 11.0886 96.9528C 6.36894 96.9528 4.69424 94.9083 4.69424 89.1583L 4.69424 73.8247L 0 73.8247L 0 88.8005C 0 97.0806 3.73002 101.297 11.0886 101.297C 19.6143 101.17 22.8368 98.0006 22.8368 89.5927L 22.8368 67.0524C 22.8368 62.9379 19.9442 56.2934 15.2246 49.3166C 9.48997 41.0109 5.45547 31.913 5.45547 27.1596L 5.45547 10.4971C 5.45547 5.66707 7.61228 3.52038 12.4588 3.52038C 16.3664 3.52038 18.1172 5.25819 18.1172 9.16824L 18.1172 26.2396L 22.6846 26.2396L 22.6846 10.2671C 22.7911 8.87966 22.5947 7.48553 22.1091 6.18266C 21.6236 4.87979 20.8607 3.69979 19.874 2.72556C 18.8874 1.75132 17.7009 1.00649 16.3979 0.543363C 15.095 0.0802365 13.7071 -0.0899511 12.3319 0.0447703C 4.87186 -0.0574534 0.608982 4.18483 0.608982 11.596Z"
        />
        <path
          id="path4_fill"
          d="M 18.6501 3.8845L 18.6501 -1.16986e-06L 7.74361e-07 -1.16986e-06L 7.74361e-07 100.588L 18.6501 100.588L 18.6501 96.7036L 4.74499 96.7036L 4.74499 50.8052L 18.1172 50.8052L 18.1172 47.074L 4.74499 47.074L 4.74499 3.8845L 18.6501 3.8845Z"
        />
        <path
          id="path5_fill"
          d="M 4.74497 0L 4.64616e-06 0L 4.64616e-06 100.588L 4.74497 100.588L 4.74497 0Z"
        />
        <path
          id="path6_fill"
          d="M 4.74498 0L 1.70359e-05 0L 1.70359e-05 100.588L 4.74498 100.588L 4.74498 0Z"
        />
        <path
          id="path7_fill"
          d="M 21.4159 -1.16986e-06L 21.4159 94.1736L 8.22126 -1.16986e-06L -1.54872e-06 -1.16986e-06L -1.54872e-06 100.588L 4.745 100.588L 4.745 1.5078L 18.6247 100.588L 26.1609 100.588L 26.1609 -1.16986e-06L 21.4159 -1.16986e-06Z"
        />
        <path
          id="path8_fill"
          d="M 25.5011 -1.16986e-06L 4.64617e-06 -1.16986e-06L 4.64617e-06 3.8845L 10.7841 3.8845L 10.7841 100.588L 15.529 100.588L 15.529 3.8845L 25.5011 3.8845L 25.5011 -1.16986e-06Z"
        />
        <path
          id="path9_fill"
          d="M 25.4758 -1.16986e-06L 1.70359e-05 -1.16986e-06L 1.70359e-05 3.8845L 10.7841 3.8845L 10.7841 100.588L 15.5037 100.588L 15.5037 3.8845L 25.4758 3.8845L 25.4758 -1.16986e-06Z"
        />
        <path
          id="path10_fill"
          d="M 2.53746 -8.57895e-06L 1.54873e-05 -8.57895e-06L 1.54873e-05 33.9383L 2.53746 33.9383L 2.53746 -8.57895e-06Z"
        />
        <path
          id="path11_fill"
          d="M 0.558237 11.596L 0.558237 27.1852C 0.558237 34.1875 6.26744 44.921 11.1393 52C 16.5694 59.8456 18.0157 65.1613 18.0157 67.0779L 18.0157 90.0783C 18.0157 96.0072 17.0261 96.9528 11.0124 96.9528C 6.29281 96.9528 4.61812 94.9083 4.61812 89.1583L 4.61812 73.8247L 0 73.8247L 0 88.8005C 0 97.0806 3.73002 101.297 11.0886 101.297C 19.6143 101.297 22.7861 98.1539 22.7861 89.7205L 22.7861 67.0524C 22.7861 62.9379 19.8934 56.2934 15.1738 49.3166C 9.41386 41.0109 5.40471 31.913 5.40471 27.1596L 5.40471 10.4971C 5.40471 5.66707 7.56153 3.52038 12.408 3.52038C 16.3157 3.52038 18.0665 5.25819 18.0665 9.16824L 18.0665 26.2396L 22.7607 26.2396L 22.7607 10.2671C 22.8672 8.87966 22.6708 7.48553 22.1853 6.18266C 21.6997 4.87979 20.9368 3.69979 19.9502 2.72556C 18.9635 1.75132 17.777 1.00649 16.4741 0.543363C 15.1711 0.0802365 13.7833 -0.0899511 12.408 0.0447703C 4.84648 -0.0574534 0.558237 4.18483 0.558237 11.596Z"
        />
        <path
          id="path12_fill"
          d="M 18.6501 3.8845L 18.6501 -1.16986e-06L -1.85846e-05 -1.16986e-06L -1.85846e-05 100.588L 18.6501 100.588L 18.6501 96.7036L 4.71959 96.7036L 4.71959 50.8052L 18.1172 50.8052L 18.1172 47.074L 4.71959 47.074L 4.71959 3.8845L 18.6501 3.8845Z"
        />
        <path
          id="path13_fill"
          d="M 23.6742 85.6634L 23.6742 -1.16986e-06L 19.0561 -1.16986e-06L 19.0561 90.3402C 19.0561 94.2247 17.2291 96.908 11.799 96.908C 6.36894 96.908 4.74499 94.5058 4.74499 90.3402L 4.74499 -1.16986e-06L 1.39385e-05 -1.16986e-06L 1.39385e-05 85.6634C 1.39385e-05 95.528 0.837363 100.614 11.4946 100.614C 22.9891 100.614 23.6742 94.0458 23.6742 85.6634Z"
        />
        <path
          id="path14_fill"
          d="M 7.0033 2.55559L 7.0033 0L -5.42053e-06 0L -5.42053e-06 34.0149L 2.53742 34.0149L 2.53742 17.6591L 6.82568 17.6591L 6.82568 15.1036L 2.53742 15.1036L 2.53742 2.55559L 7.0033 2.55559Z"
        />
        <path
          id="path15_fill"
          d="M 0.0253678 5.80943L 0.0253678 28.8098C -0.0466197 29.5447 0.0349731 30.2867 0.264897 30.9879C 0.494821 31.6892 0.867989 32.3342 1.36037 32.8814C 1.85275 33.4286 2.45343 33.866 3.12376 34.1653C 3.7941 34.4646 4.51923 34.6192 5.25248 34.6192C 5.98574 34.6192 6.71085 34.4646 7.38119 34.1653C 8.05152 33.866 8.6522 33.4286 9.14458 32.8814C 9.63696 32.3342 10.0101 31.6892 10.2401 30.9879C 10.47 30.2867 10.5516 29.5447 10.4796 28.8098L 10.4796 5.80943C 10.5516 5.0745 10.47 4.33253 10.2401 3.63128C 10.0101 2.93002 9.63696 2.28502 9.14458 1.73778C 8.6522 1.19055 8.05152 0.753223 7.38119 0.453925C 6.71085 0.154628 5.98574 1.13098e-06 5.25248 1.13098e-06C 4.51923 1.13098e-06 3.7941 0.154628 3.12376 0.453925C 2.45343 0.753223 1.85275 1.19055 1.36037 1.73778C 0.867989 2.28502 0.494821 2.93002 0.264897 3.63128C 0.0349731 4.33253 -0.0466197 5.0745 0.0253678 5.80943ZM 2.5628 28.8098L 2.5628 5.80943C 2.5099 5.42248 2.53993 5.0286 2.65086 4.65432C 2.76179 4.28003 2.95106 3.93402 3.2059 3.63958C 3.46075 3.34515 3.77528 3.10913 4.1283 2.9474C 4.48133 2.78567 4.86465 2.70198 5.25248 2.70198C 5.64031 2.70198 6.02364 2.78567 6.37666 2.9474C 6.72969 3.10913 7.0442 3.34515 7.29905 3.63958C 7.55389 3.93402 7.74316 4.28003 7.85409 4.65432C 7.96502 5.0286 7.99505 5.42248 7.94215 5.80943L 7.94215 28.8098C 7.99505 29.1967 7.96502 29.5906 7.85409 29.9649C 7.74316 30.3392 7.55389 30.6852 7.29905 30.9796C 7.0442 31.274 6.72969 31.5101 6.37666 31.6718C 6.02364 31.8335 5.64031 31.9172 5.25248 31.9172C 4.86465 31.9172 4.48133 31.8335 4.1283 31.6718C 3.77528 31.5101 3.46075 31.274 3.2059 30.9796C 2.95106 30.6852 2.76179 30.3392 2.65086 29.9649C 2.53993 29.5906 2.5099 29.1967 2.5628 28.8098Z"
        />
        <path
          id="path16_fill"
          d="M 0.0127061 5.80943L 0.0127061 28.8098C -0.037342 29.5337 0.0610006 30.2602 0.301659 30.9442C 0.542318 31.6282 0.920131 32.255 1.41159 32.7856C 1.90305 33.3162 2.49763 33.7394 3.15839 34.0287C 3.81916 34.318 4.53196 34.4673 5.25246 34.4673C 5.97296 34.4673 6.68576 34.318 7.34653 34.0287C 8.00729 33.7394 8.60191 33.3162 9.09337 32.7856C 9.58483 32.255 9.96264 31.6282 10.2033 30.9442C 10.444 30.2602 10.5423 29.5337 10.4923 28.8098L 10.4923 5.80943C 10.5642 5.0745 10.4827 4.33253 10.2527 3.63128C 10.0228 2.93002 9.64963 2.28502 9.15726 1.73778C 8.66488 1.19055 8.06421 0.753223 7.39388 0.453925C 6.72355 0.154628 5.99841 1.13098e-06 5.26516 1.13098e-06C 4.53191 1.13098e-06 3.80677 0.154628 3.13644 0.453925C 2.46611 0.753223 1.86544 1.19055 1.37307 1.73778C 0.880688 2.28502 0.507501 2.93002 0.277576 3.63128C 0.0476524 4.33253 -0.033921 5.0745 0.0380665 5.80943L 0.0127061 5.80943ZM 2.55013 28.8098L 2.55013 5.80943C 2.51357 5.42985 2.55622 5.04677 2.67539 4.68479C 2.79456 4.32281 2.98761 3.98991 3.2421 3.70753C 3.4966 3.42515 3.80692 3.19952 4.15314 3.0451C 4.49936 2.89068 4.87381 2.81091 5.25246 2.81091C 5.63111 2.81091 6.0056 2.89068 6.35182 3.0451C 6.69805 3.19952 7.00837 3.42515 7.26286 3.70753C 7.51735 3.98991 7.71037 4.32281 7.82954 4.68479C 7.94871 5.04677 7.99139 5.42985 7.95483 5.80943L 7.95483 28.8098C 8.00773 29.1967 7.97771 29.5906 7.86678 29.9649C 7.75585 30.3392 7.56657 30.6852 7.31172 30.9796C 7.05687 31.274 6.74236 31.5101 6.38934 31.6718C 6.03632 31.8335 5.65299 31.9172 5.26516 31.9172C 4.87733 31.9172 4.494 31.8335 4.14098 31.6718C 3.78796 31.5101 3.47345 31.274 3.2186 30.9796C 2.96375 30.6852 2.77447 30.3392 2.66354 29.9649C 2.55261 29.5906 2.5226 29.1967 2.57549 28.8098L 2.55013 28.8098Z"
        />
        <path
          id="path17_fill"
          d="M 1.26873 3.63171e-14L 1.23898e-05 3.63171e-14L 1.23898e-05 34.2449L 5.22711 34.2449C 6.65626 34.1982 8.00878 33.583 8.98849 32.534C 9.9682 31.485 10.4952 30.0877 10.4542 28.6482L 10.4542 5.64786C 10.4814 4.93289 10.3683 4.21955 10.1215 3.54862C 9.8747 2.8777 9.49903 2.26238 9.01591 1.73782C 8.53278 1.21327 7.95172 0.789785 7.30596 0.491593C 6.6602 0.193402 5.96239 0.0263494 5.25247 3.63171e-14L 1.26873 3.63171e-14ZM 5.22711 2.55559C 5.98343 2.60171 6.69089 2.94747 7.19488 3.51731C 7.69886 4.08716 7.95839 4.83477 7.91678 5.59675L 7.91678 28.5971C 7.95839 29.3591 7.69886 30.1067 7.19488 30.6765C 6.69089 31.2463 5.98343 31.5921 5.22711 31.6382L 2.53744 31.6382L 2.53744 2.55559L 5.22711 2.55559Z"
        />
        <path
          id="path18_fill"
          d="M 11.2154 33.9383L 13.7528 33.9383L 8.67799 -3.11962e-06L 5.07485 -3.11962e-06L 1.54872e-06 33.9383L 2.53743 33.9383L 4.00914 24.0992L 9.7437 24.0992L 11.2154 33.9383ZM 4.33901 21.8759L 6.87644 2.17225L 9.41386 21.8759L 4.33901 21.8759Z"
        />
        <path
          id="path19_fill"
          d="M 7.18092 0L 7.18092 15.2058L 2.53743 15.2058L 2.53743 0L 0 0L 0 33.9638L 2.53743 33.9638L 2.53743 17.7614L 7.18092 17.7614L 7.18092 33.9638L 9.71835 33.9638L 9.71835 0L 7.18092 0Z"
        />
        <path
          id="path20_fill"
          d="M 53.5346 132.567C 48.2891 147.339 45.1371 162.782 44.1714 178.44C 42.5475 204.635 43.4864 207.446 44.3998 208.621C 45.3133 209.797 46.9372 219.866 45.567 221.399C 44.1968 222.933 39.7563 218.128 38.1324 199.651C 36.5084 181.174 36.2801 157.765 39.7563 139.288C 43.2326 120.811 50.8956 108.877 52.4435 111.432C 53.9913 113.988 58.6094 145.907 63.9126 159.017C 69.2158 172.128 70.6622 174.351 70.1801 171.668C 67.9496 153.961 66.6284 136.151 66.2217 118.307C 66.2217 98.4243 78.2998 61.4449 81.4462 49.9703C 69.6437 60.1136 56.6064 68.7014 42.649 75.5262C 18.9494 87.2309 5.24733 87.2308 1.28895 84.6497C -2.66944 82.0686 3.62338 75.2962 5.01897 75.7562C 6.41455 76.2163 11.9969 80.433 31.2813 75.2962C 50.5658 70.1595 74.9504 51.427 84.7195 27.3278C 94.4886 3.22854 92.0273 -0.553738 93.6513 0.0596038C 96.0881 0.793978 98.1381 2.46839 99.3548 4.71812C 100.571 6.96786 100.856 9.61066 100.147 12.0709C 98.5231 20.9643 91.5959 33.2823 83.9837 57.4582C 76.3714 81.6341 75.1534 102.616 74.2146 125.539C 73.2757 148.463 80.482 181.762 81.6492 188.943C 82.8165 196.125 84.6688 200.162 77.6908 195.026C 70.7129 189.889 64.3694 183.117 53.5346 132.567Z"
        />
        <path
          id="path21_fill"
          d="M 15.0301 0.0182769C 10.6657 0.197168 6.02221 3.34055 2.0892 11.774C -1.84381 20.2075 0.033894 31.6309 5.56548 33.8799C 11.0971 36.1288 20.5363 29.5609 21.7035 15.5563C 22.8707 1.55163 18.0496 -0.211726 15.0301 0.0182769ZM 17.1615 19.8752C 14.2181 25.8042 7.7984 29.842 5.48935 21.4086C 3.18029 12.9751 11.5538 3.51944 15.3092 3.90278C 19.0646 4.28612 18.278 11.0329 17.4406 13.8696C 16.8063 15.8885 20.1049 13.844 17.1615 19.773L 17.1615 19.8752Z"
        />
      </defs>
    </Svg>
  );
};

const pulse = keyframes`
  25% {
    transform: scale(1.02);
  }
  75% {
    transform: scale(0.98);
}
`;

const Svg = styled.svg`
  && {
    transform: translateZ(0);

    ${props =>
      props.animated &&
      `&:hover {
      animation-name: ${pulse};
      animation-duration: 3s;
      animation-timing-function: linear;
      animation-iteration-count: infinite;
    }`}
  }
`;

const HoverGroup = styled.g``;
